import Typography from '@mui/material/Typography';
import { KmxContainer } from '../../../components/KmxContainer';

const BuyingOnlineDisclaimer = () => (
    <KmxContainer maxWidth="xl" sx={{ mt: { xs: 10, sm: 15 }, mb: 3 }}>
        <Typography variant="caption" color="textSecondary" component="p">
            &dagger; CarMax delivery is available within a 60-mile radius of select stores. Not available to customers
            in all states. Please contact your nearest store for details. Applicable store-to-store shipping fees are
            due in advance of vehicle delivery and are separate from sales transactions.
        </Typography>
    </KmxContainer>
);

export default BuyingOnlineDisclaimer;
